import { ReactComponent as ConfegrateActiveIcon } from '../../../assets/icons/sidebar/configeration-active.svg';
import { ReactComponent as ConfegrateIcon } from '../../../assets/icons/sidebar/configeration.svg';
import { ReactComponent as RevenueActiveIcon } from '../../../assets/icons/sidebar/revenue-active.svg';
import { ReactComponent as RevenueIcon } from '../../../assets/icons/sidebar/revenue.svg';
import { ReactComponent as AccountActiveIcon } from '../../../assets/icons/sidebar/sidebar-account-active.svg';
import { ReactComponent as AccountIcon } from '../../../assets/icons/sidebar/sidebar-account.svg';
import { ReactComponent as ReportActiveIcon } from '../../../assets/icons/sidebar/sidebar-report-active.svg';
import { ReactComponent as ReportIcon } from '../../../assets/icons/sidebar/sidebar-report.svg';
import { ReactComponent as StationActiveIcon } from '../../../assets/icons/sidebar/sidebar-station-active.svg';
import { ReactComponent as StationIcon } from '../../../assets/icons/sidebar/sidebar-station.svg';
import { MenuItem } from '../../../interface/menuItem-interfaces';
import getFirstSubdomain from '../../../shared-functions/DomainsplitFunction';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';

const subdomain = getFirstSubdomain();
const shouldHideAccessUtility = Boolean(subdomain);

/**
 * EMSP Menus List
 */
const EMSPMenu = (): MenuItem[] => [
  {
    id: 'accounts',
    label: 'accounts',
    svgIcon: <AccountIcon />,
    activeSvgIcon: <AccountActiveIcon />,
    allow: permissionCheck('mobilityEndConsumerView'),
    children: [
      {
        id: 'endConsumer',
        label: 'endConsumer',
        url: '/ev-admin/end-consumer',
        allow: permissionCheck('mobilityEndConsumerView'),
        permissionKey: 'mobilityEndConsumerView',
      },
    ],
  },

  {
    id: 'operations',
    label: 'operations',
    svgIcon: <StationIcon />,
    activeSvgIcon: <StationActiveIcon />,
    allow:
      permissionCheck('mobilityChargersView') ||
      permissionCheck('mobilitySessionsView') ||
      permissionCheck('mobilityGuestUserView'),
    children: [
      {
        id: 'personal-charger',
        label: 'persnalChargers',
        url: '/ev-admin/operations/personal-charger',
        allow: permissionCheck('mobilityChargersView'),
        permissionKey: 'mobilityChargersView',
      },

      {
        id: 'sessions',
        label: 'sessions',
        url: '/ev-admin/operations/emsp-sessions',
        allow: permissionCheck('mobilitySessionsView'),
        permissionKey: 'mobilitySessionsView',
      },

      {
        id: 'guestCharging',
        label: 'Guest Charging',
        url: '/ev-admin/operations/guest-charging',
        allow: permissionCheck('mobilityGuestUserView'),
        permissionKey: 'mobilityGuestUserView',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'revenue',
    allow: permissionCheck('mobilityTransactionsView') || permissionCheck('mobilityPayoutsView'),
    svgIcon: <RevenueIcon />,
    activeSvgIcon: <RevenueActiveIcon />,
    children: [
      {
        id: 'transaction',
        label: 'transactions',
        url: '/ev-admin/revenue/emsp-transactions',
        allow: permissionCheck('mobilityTransactionsView'),
        permissionKey: 'mobilityTransactionsView',
      },
      {
        id: 'payments',
        label: 'payments',
        url: '/ev-admin/revenue/emsp-payments',
        allow: !shouldHideAccessUtility && permissionCheck('mobilityPayoutsView'),
        permissionKey: 'mobilityPayoutsView',
      },
      {
        id: 'payouts',
        label: 'emspPayouts',
        url: '/ev-admin/revenue/emsp-payouts/approved',
        allow: !shouldHideAccessUtility && permissionCheck('mobilityPayoutsView'),
        permissionKey: 'mobilityPayoutsView',
      },
      {
        id: 'invoice',
        label: 'Invoice',
        url: '/ev-admin/revenue/invoice',
        allow: !shouldHideAccessUtility && permissionCheck('mobilityPayoutsView'),
        permissionKey: 'mobilityPayoutsView',
      }
    ],
  },

  {
    id: 'configuration',
    label: 'configuration',
    svgIcon: <ConfegrateIcon />,
    activeSvgIcon: <ConfegrateActiveIcon />,
    allow:
      permissionCheck('mobilityFeeConfigurationView') ||
      permissionCheck('mobilityPaymentGatewayView'),
    children: [
      {
        id: 'feeConfiguration',
        label: 'feeConfiguration',
        url: '/ev-admin/configuration/fee-configuration',
        allow: permissionCheck('mobilityFeeConfigurationView'),
        permissionKey: 'mobilityFeeConfigurationView',
      },
      {
        id: 'paymentGateway',
        label: 'paymentGateway',
        url: '/ev-admin/configuration/paymentGateway',
        allow: permissionCheck('mobilityPaymentGatewayView'),
        permissionKey: 'mobilityPaymentGatewayView',
      },
      // {
      //   id: 'scheduleManagement',
      //   label: 'Charging Schedule',
      //   url: '/ev-admin/schedule-management',
      //   allow: permissionCheck('report'),
      //   permissionKey: 'report',
      // },
    ],
  },

  {
    id: 'reports',
    label: 'reports',
    svgIcon: <ReportIcon />,
    activeSvgIcon: <ReportActiveIcon />,
    url: '/ev-admin/reports/energyReport',
    allow:
      permissionCheck('mobilityEnergyReportView') || permissionCheck('mobilityRevenueReportView'),
    children: [
      {
        id: 'energyReport',
        label: 'energyReport',
        url: '/ev-admin/reports/energyReport',
        allow: permissionCheck('mobilityEnergyReportView'),
        permissionKey: 'mobilityEnergyReportView',
      },

      {
        id: 'revenueReport',
        label: 'revenueReport',
        url: '/ev-admin/reports/revenueReport',
        allow: permissionCheck('mobilityRevenueReportView'),
        permissionKey: 'mobilityRevenueReportView',
      },
    ],
  },
];

export default EMSPMenu;
